module.exports = __webpack_public_path__ + "static/media/rms-logo.7f06c117.svg";